import { render, staticRenderFns } from "./SimpleModel.vue?vue&type=template&id=7e863874&lang=pug&"
import script from "./SimpleModel.vue?vue&type=script&lang=js&"
export * from "./SimpleModel.vue?vue&type=script&lang=js&"
import style0 from "./SimpleModel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports